import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import moment from 'moment';
import * as FileSaver from 'file-saver';
import { GraphService } from 'src/app/services/graph.service';
declare const $:any;

@Component({
  selector: 'smart-overview-graph',
  templateUrl: './overview-graph.component.html',
  styleUrls: ['../graph-color.css','../../platform-color/platform-color.css']
})
export class OverviewGraphComponent implements OnInit {
  limitGraphModal: string = '#limitGraphModal';
  number_of_graph: number = 1;
  graphList = [1];

  canExport: boolean = false;
  download: boolean = false;
  filters = [];
  constructor(
    private GraphService: GraphService,
    private cd: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    const currentPackage = JSON.parse(sessionStorage.getItem('package'));
    const system_role = sessionStorage.getItem('system_role');
    const farmId = sessionStorage.getItem('farmId');

    if(currentPackage && currentPackage['package_id']){
      this.GraphService.getPackage(currentPackage['package_id']).then(res=>{
        this.number_of_graph = res.data.report_no;
      })
    }

    if(system_role == 'global_admin' || system_role == 'super_admin' || system_role == 'admin_child'){
      this.canExport = true;
    }else{
      if(farmId){
        await this.GraphService.getPlotDashboard(farmId)
        .then(success => {
          if(success.data.role == 'farm_manager'){
            this.canExport = true;
          }else{
            this.canExport = false;
          }
        })
      }else{
        this.canExport = false;
      }
    }
    
    if(!JSON.parse(sessionStorage.getItem('graph_setting'))){
      sessionStorage.setItem('graph_setting', null);
    }
  }

  addGraph(){
    if(this.graphList.length === this.number_of_graph){
      $(`${this.limitGraphModal}`).modal('show');
    }else{
      this.graphList.push(this.graphList.length +1);
    }
  }

  async export(type: string){
    if(this.filters.length > 0){
      this.download = true;

      await Promise.all(this.filters
        .map(async filter=>{
          for (let i = 0; i < filter.sen_left.length; i++) {

            await this.GraphService.exportSensorData( filter.thing_left[0].id, filter.sen_left[i].id, filter.receive_date, type).then(res=>{
              if(res){
    
                this.downloadFile(res, type, filter.sen_left[i].label);
              }
            }).catch(err=>{
              this.download = false;
              this.resetTemplate();
            })
          }
          for (let i = 0; i < filter.sen_right.length; i++) {
    
            await this.GraphService.exportSensorData( filter.thing_right[0].id, filter.sen_right[i].id, filter.receive_date, type).then(res=>{
              if(res){
         
                this.downloadFile(res, type, filter.sen_right[i].label);
              }
            }).catch(err=>{
              this.download = false;
              this.resetTemplate();
            })
          }
      }));
      this.download = false;
      this.resetTemplate();
    }
  }

  filter(e, index){
    let data = {
      ...e,
      index: index
    }
    if(this.filters.length == 0){
      this.filters.push(data);
    }else{
      if(this.filters.find(fil=> fil.index == index)){
        this.filters[index] = data;
      }else{
        this.filters.push(data);
      }
    }
  }

  downloadFile(file, type, sensor_name) {
    let fileName = 'รายงานการวิเคราะห์ข้อมูลเซนเซอร์(Sensor data Analytics)_'+sensor_name+'_'+moment(new Date()).format('YYYYMMDD_HHmmss')+'.'+type;
    if(type == 'xlsx'){
  
      var blob = new Blob([file.body]);
      FileSaver.saveAs(blob, fileName);
    }else{

      var blob = new Blob(['\ufeff' + file], {type: 'text/csv;charset=utf-8'})
      FileSaver.saveAs(blob, fileName);
    }
  }

  resetTemplate(){
    this.cd.detectChanges();
  }
}
